import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../ui/button';
import {
  Certificate, SpinnerGap, User, CalendarBlank, IdentificationCard, Globe, GearSix
} from '@phosphor-icons/react';
import { TemplateSelector, FormField, DateField, HistoryList, HistoryPanel } from './FormFields';

export const EmploymentTab = ({
  employmentTemplates, selectedEmploymentTemplateId, setSelectedEmploymentTemplateId,
  employmentForm, setEmploymentForm, isGeneratingEmployment, isAdmin,
  employmentContracts, loadingEmployment,
  onGenerate, onDownload, onDelete
}) => {
  const navigate = useNavigate();

  return (
    <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
      <div className="lg:col-span-2">
        <div className="border border-[#262626] bg-[#141414]">
          <div className="p-4 border-b border-[#262626]">
            <h2 className="text-xs uppercase tracking-[0.2em] font-semibold text-[#A3A3A3]">Трудовой договор</h2>
            <p className="text-xs text-[#525252] mt-1">Выберите шаблон и заполните данные сотрудника</p>
          </div>
          <div className="p-4 grid grid-cols-1 md:grid-cols-2 gap-4">
            <div className="md:col-span-2">
              <TemplateSelector templates={employmentTemplates} selectedId={selectedEmploymentTemplateId}
                onSelect={setSelectedEmploymentTemplateId} testId="employment-template-select" isAdmin={isAdmin} />
            </div>
            {employmentTemplates.length > 0 ? (
              <>
                <FormField icon={User} label="ФИО сотрудника" value={employmentForm.fullName}
                  onChange={(v) => setEmploymentForm(p => ({...p, fullName: v}))} placeholder="URBEKOV SAVYRBEK" testId="employment-name-input" />
                <FormField icon={IdentificationCard} label="Номер паспорта" value={employmentForm.passportNumber}
                  onChange={(v) => setEmploymentForm(p => ({...p, passportNumber: v}))} placeholder="PE1736602" testId="employment-passport-input" />
                <FormField icon={CalendarBlank} label="Дата рождения" value={employmentForm.dateOfBirth}
                  onChange={(v) => setEmploymentForm(p => ({...p, dateOfBirth: v}))} placeholder="04.04.1974" testId="employment-dob-input" />
                <FormField icon={Globe} label="Страна" value={employmentForm.country}
                  onChange={(v) => setEmploymentForm(p => ({...p, country: v}))} placeholder="KYRGYZ REPUBLIC" testId="employment-country-input" />
                <div className="md:col-span-2">
                  <DateField label="Дата документа" date={employmentForm.documentDate}
                    onDateChange={(d) => setEmploymentForm(p => ({...p, documentDate: d}))} testId="employment-date-picker" />
                </div>
              </>
            ) : (
              <div className="md:col-span-2 text-center py-8">
                <Certificate size={48} className="mx-auto mb-3 text-[#525252] opacity-30" />
                <p className="text-sm text-[#525252]">Загрузите шаблоны в Настройках</p>
                {isAdmin && <Button onClick={() => navigate('/settings')} variant="outline"
                  className="mt-4 border-[#FACC15] text-[#FACC15] hover:bg-[#FACC15]/10 rounded-none">
                  <GearSix size={16} className="mr-2" />Настройки</Button>}
              </div>
            )}
          </div>
          {employmentTemplates.length > 0 && (
            <div className="p-4 border-t border-[#262626]">
              <Button onClick={onGenerate} disabled={isGeneratingEmployment || !selectedEmploymentTemplateId}
                className="w-full h-12 bg-[#FACC15] hover:bg-[#EAB308] text-[#0A0A0A] font-semibold rounded-none disabled:opacity-50"
                data-testid="generate-employment-btn">
                {isGeneratingEmployment ? <><SpinnerGap size={20} className="animate-spin mr-2" />Генерация...</>
                  : <><Certificate size={20} className="mr-2" weight="bold" />Создать трудовой договор</>}
              </Button>
            </div>
          )}
        </div>
      </div>
      <HistoryPanel title="История" count={employmentContracts.length}>
        <HistoryList items={employmentContracts} loading={loadingEmployment}
          onDownload={onDownload} onDelete={onDelete}
          subtitleField="template_name" testPrefix="employment-item" />
      </HistoryPanel>
    </div>
  );
};
